module.exports = __webpack_public_path__ + "img/icon-cont-4.702262a1.png";